import React, { Component } from 'react';
import Modal from '../../components/modal/modal';

export default class ModalConfirmarCancelamentoAssinatura extends Component {
    render() {
        return (
            <div>
                <Modal open={this.props.openModal} close={this.props.onCloseModal} sizeClassName={'modal-content-lg'}>
                    <div>
                        <div className="text-modal-justify">
                            <span>O processo de cancelamento da assinatura está em andamento. Nosso time logo entrará em contato para alinhar os detalhes do cancelamento.</span>
                            <br />
                            <br />
                            <span>Qualquer dúvida nos contate através dos canais: atendimento@bhs.com.br ou 4000-1744</span>
                        </div>

                        <div className="btn-modal">
                            <button type="button" onClick={() => this.props.onCloseModal()} className="btn btn-danger">Fechar</button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    };
}